import { getDate } from 'services/types';

export const getTableParams = (t) => {
  const fields = [
    {
      name: 'created_at',
      title: t('grid.Дата и время'),
      width: 'auto',
      sortField: 'created_at',
      render: (val) => (val === null ? '' : getDate(val)),
    },
    {
      name: 'success',
      title: t('grid.Статус'),
      width: 'auto',
      sortField: 'success',
      render: (val) => (val === false ? 'Ожидается' : 'Возвращена'),
    },
    {
      name: 'amount',
      title: t('grid.Сумма'),
      width: 'auto',
      sortField: 'amount',
      render: (val) => (val === null ? '' : Math.abs(val / 100).toFixed(2)),
    },
    {
      name: 'vehicle_plate',
      title: t('sections.ГРЗ'),
      width: 'auto',
    },
    {
      name: 'confirm_time',
      title: t('grid.Дата и вpeмя платежа'),
      width: 'auto',
      sortField: 'confirm_time',
      render: (val) => getDate(val),
    },
    {
      name: 'mean_id',
      title: t('grid.Номер платежа'),
      width: 'auto',
      render: (val) => val,
    },
  ];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  return { fields, getRowClass, withComment: false };
};
